import { FormBase } from "../../util/form-base-form";

class UserProfilePasswordForm extends FormBase {
    public getPasswordInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[name="password"]');
    }

    public getPasswordConfirmationInput(root: ParentNode): HTMLInputElement | null {
        return this.getInput(root, 'input[name="password_confirmation"]');
    }

    public getSubmitButton(root: ParentNode): HTMLButtonElement | null {
        return this.queryElement(root, 'button[type="submit"], input[type="submit"]', HTMLButtonElement);
    }

    public getPasswordInputs(root: ParentNode): HTMLInputElement[] {
        return this.queryElements(root, 'input[type="password"]', HTMLInputElement);
    }
}

const userProfilePasswordForm = new UserProfilePasswordForm();

export { UserProfilePasswordForm, userProfilePasswordForm };
